import { yupResolver } from '@hookform/resolvers/yup'
import { Auth } from 'aws-amplify'
import { NextSeo } from 'next-seo'
import { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import { object, string } from 'yup'

import AuthBg from '@/assets/illustrations/auth.svg'
import Button, { ButtonVariant } from '@/components/button'
import Input from '@/components/input'
import Link from '@/components/link'
import handleApiError from '@/utils/handle-api-error'
import protectedRoute from '@/utils/protected-route'

const schema = object({
  email: string().email().required(),
  password: string().min(8).required(),
}).required()

const Register = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) })

  const [usernameExistsError, toggleUsernameExistsError] = useState('')

  const onSubmit = useCallback(
    ({ name, email, password }) => {
      toggleUsernameExistsError('')
      Auth.signUp({
        username: email,
        password,
        attributes: {
          email,
          name,
        },
      }).catch((e) => {
        if (e?.code === 'UsernameExistsException') {
          toggleUsernameExistsError(email)
        } else {
          handleApiError(e)
        }
      })
    },
    [toggleUsernameExistsError],
  )

  return (
    <div className='flex h-[100%] min-h-full flex-wrap items-end self-end bg-theme-turquoise px-5'>
      <NextSeo title='Register' />
      <div className='py-custom flex-[0_0_100%] px-16'>
        {/* <div className='flex justify-between self-center pt-14'>
          <div>
            <Link href='/auth/login' className='signIn-button'>
              SIGN IN
            </Link>
          </div>
          <div>
            <Button
              variant={ButtonVariant.Primary}
              bg='bg-[#234370]'
              tailFill='#234370'
              className='w-fit !px-5 rounded-3xl py-1.5 !text-white uppercase'
              tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[41%] h-2'
            >
              <Link href='/auth/login'>
                <span className='signIn-button'>SIGN IN</span>
              </Link>
            </Button>
          </div>
        </div> */}
        <div className='relative'>
          <div className='py-4'>
            <form
              className='auth-form flex flex-col items-end space-y-2'
              onSubmit={handleSubmit(onSubmit)}
            >
              <Input
                id='name'
                name='name'
                label='Name'
                type='text'
                required
                register={register}
                errors={errors}
              />

              <Input
                name='email'
                label='Email'
                type='email'
                autoComplete='email'
                required
                register={register}
                errors={errors}
              />

              <Input
                name='password'
                type='password'
                label='Password'
                autoComplete='new-password'
                required
                register={register}
                errors={errors}
              />

              {Boolean(usernameExistsError) && (
                <p className='text-center text-red-600'>
                  User with email <span>"{usernameExistsError}"</span> already
                  exists. Try{' '}
                  <Link
                    href={`/auth/login?email=${usernameExistsError}`}
                    className='text-red-600 underline hover:text-red-800'
                  >
                    logging in
                  </Link>{' '}
                  or use{' '}
                  <Link
                    href={`/auth/forgot-password?email=${usernameExistsError}`}
                    className='text-red-600 underline hover:text-red-800'
                  >
                    forgot password
                  </Link>{' '}
                  to create a new password.
                </p>
              )}
              <div className='flex w-full items-center justify-end pt-2'>
                <Button
                  type='submit'
                  variant={ButtonVariant.Primary}
                  bg='bg-white'
                  tailFill='white'
                  className='custom-font22 w-fit px-5 py-1.5'
                  tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[40%]'
                >
                  Sign Up
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='flex-[0_0_100%] self-end'>
        <img src={`${AuthBg.src}`} className='mx-auto' />
      </div>
      <style jsx>
        {`
          .signIn-button {
            font-family: 'Overpass';
            font-weight: 400;
            font-size: 25pt;
            line-height: 30pt;
          }
          .py-custom {
            max-width: 524px;
            margin: 200px auto 20px;
          }
          form.auth-form {
            margin-top: 50px;
          }
          @media (max-width: 1920px) {
            .py-custom {
              max-width: calc(
                320px + (524 - 320) * (100vw - 375px) / (1920 - 375)
              );
              margin: calc(115px + (200 - 115) * (100vw - 375px) / (1920 - 375))
                auto 20px;
            }
            .signIn-button {
              font-size: calc(8pt + (25 - 12) * (100vw - 281pt) / (1920 - 375));
              line-height: calc(
                10pt + (30 - 15) * (100vw - 281pt) / (1920 - 375)
              );
            }
          }
        `}
      </style>
    </div>
  )
}

export default protectedRoute(Register, { preventLoggedInUsers: true })
